<!-- <h3 class="ui primary header">
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3> -->

<div class="close">
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</div>

<div class="content">
  <div class="ui vertical basic segment" *ngIf="!documentPath" [ngClass]="(!documentPath && showMessage == false)? 'loading':''">
  </div>

  <div style="display: flex; flex-direction: column; gap: 40px;">
      <sui-message class="info" *ngIf="showMessage" style="padding: 80px;">
        <p>The deposit slip is currently not available for this transaction.</p>
      </sui-message>
      <img *ngIf="documentPath || showMessage" [src]="documentPath ? safeImageUrl : ''" alt="deposit slip">
  </div>

</div>
